import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "@/api/core";
import { useAuth } from "@/contexts/auth/useAuth";
import { useApi } from "@/hooks";
import { type PremiumFeature } from "@/schemas";

const usePremiumFeatures = () => {
  const { currentAccount } = useAuth();
  const api = useApi();

  return useQuery({
    enabled: !!currentAccount,
    queryKey: QueryKeys.premiumFeatures.global,
    queryFn: async () => {
      const { data } = await api.get<PremiumFeature[]>("/api/v1/features");
      return data;
    },
  });
};

export { usePremiumFeatures };
